module.exports = __webpack_public_path__ + "img/img-work_detail_2.aecbb61b.png";